// Centralized data-testid constants for automated testing
export const AUTH = {
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginPasswordToggle: "login-password-toggle",
  loginRemember: "login-remember-checkbox",
  loginSubmit: "login-submit-btn",
  loginError: "login-error-msg",
  logoutBtn: "logout-btn",
};

export const LAYOUT = {
  sidebar: "app-sidebar",
  sidebarToggle: "sidebar-toggle-btn",
  topbar: "app-topbar",
  cmdkTrigger: "cmdk-trigger-btn",
  cmdkPalette: "cmdk-palette",
  userMenu: "user-menu-btn",
};

export const DASHBOARD = {
  root: "dashboard-root",
  metricServices: "metric-services",
  metricPortfolio: "metric-portfolio",
  metricLeads: "metric-leads",
  metricRevenue: "metric-revenue",
  chartVisitors: "chart-visitors",
  recentActivity: "recent-activity-panel",
  recentLeads: "recent-leads-panel",
};

export const CRUD = {
  root: (r) => `${r}-page`,
  searchInput: (r) => `${r}-search-input`,
  addBtn: (r) => `${r}-add-btn`,
  editBtn: (r, id) => `${r}-edit-${id}`,
  deleteBtn: (r, id) => `${r}-delete-${id}`,
  drawer: (r) => `${r}-drawer`,
  saveBtn: (r) => `${r}-save-btn`,
};

export const MEDIA = {
  root: "media-page",
  uploadBtn: "media-upload-btn",
  fileInput: "media-file-input",
  grid: "media-grid",
};

export const LEADS = {
  root: "leads-page",
  kanban: "leads-kanban",
  table: "leads-table",
  viewToggle: "leads-view-toggle",
};

export const HOME = { brandLink: "brand-link" };
